import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as pdfjsLib from "pdfjs-dist/webpack";

const CandidateResumeModal = ({ openPdf, onClose, candidate }) => {
  const [imageSrcs, setImageSrcs] = useState([]);

  useEffect(() => {
    if (!openPdf || !candidate?.resume) return;
    convertPdfToImages(candidate.resume);
  }, [openPdf, candidate?.resume]);

  const convertPdfToImages = async (pdfUrl) => {
    try {
      const loadingTask = pdfjsLib.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;
      const numPages = pdf.numPages;
      const newImageSrcs = [];

      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const scale = 2;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;
        newImageSrcs.push(canvas.toDataURL("image/png"));
      }

      setImageSrcs(newImageSrcs);
    } catch (error) {
      console.error("Error converting PDF:", error);
      setImageSrcs([]);
    }
  };

  const handleDownload = () => {
    if (!candidate?.resume) return;
    
    const link = document.createElement("a");
    link.href = candidate.resume;
    link.download = `${candidate.first_name}_${candidate.last_name}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleClose = () => {
    setImageSrcs([]);
    onClose();
  };

  return (
    <Dialog open={openPdf} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      {candidate.first_name} {candidate.last_name}  Resume
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      {candidate?.resume && (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 2 }}>
    <Button 
      variant="contained" 
      color="primary" 
      onClick={handleDownload}
      sx={{ ml: 2 }}
    >
      Download Resume
    </Button>
  </Box>
)}
        <div>
          {candidate?.resume ? (
            imageSrcs.length > 0 ? (
              imageSrcs.map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Resume Page ${index + 1}`}
                  style={{ width: "100%", marginBottom: "20px" }}
                />
              ))
            ) : (
              <p>Loading resume preview...</p>
            )
          ) : (
            <p>No Resume Found</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CandidateResumeModal;